<div class="fixed bottom-5 right-5 z-[60] w-[min(100vw-1.5rem,26rem)] max-h-[80vh]">
  <div class="flex flex-col h-[600px] w-full max-w-md mx-auto border border-gray-200 rounded-xl shadow-lg bg-white overflow-hidden">
    
    <!-- Header -->
    <div class="bg-[#03492f] p-4 text-white font-semibold">
      Customer Support
    </div>

    <!-- Chat History -->
    <div #chatContainer class="flex-1 p-4 overflow-y-auto bg-gray-50 flex flex-col gap-3">
      
      @for (msg of messages(); track $index) {
        <div [ngClass]="{
          'self-end bg-[#2F5D50] text-white': msg.role === 'user',
          'self-start bg-white border border-gray-200 text-gray-800': msg.role === 'ai'
        }" class="px-4 py-2 rounded-2xl max-w-[85%] shadow-sm text-sm whitespace-pre-wrap">
          {{ msg.content }}
        </div>
      }

      <!-- Loading Indicator -->
      @if (isLoading()) {
        <div class="self-start bg-white border border-gray-200 text-gray-500 px-4 py-2 rounded-2xl shadow-sm text-sm animate-pulse">
          Typing...
        </div>
      }
    </div>

    <!-- Input Area -->
    <div class="p-3 bg-white border-t border-gray-200 flex gap-2">
      <input 
        type="text" 
        [ngModel]="userInput()" 
        (ngModelChange)="userInput.set($event)"
        (keydown.enter)="sendMessage()"
        placeholder="Type a message..."
        class="flex-1 px-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
      />
      <button 
        (click)="sendMessage()" 
        [disabled]="isLoading() || !userInput().trim()"
        class="bg-blue-600 text-white px-5 py-2 rounded-full font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        Send
      </button>
    </div>
  </div>
</div>